import { render, staticRenderFns } from "./MigrationNotice.vue?vue&type=template&id=85fc3996&scoped=true&"
import script from "./MigrationNotice.vue?vue&type=script&lang=ts&"
export * from "./MigrationNotice.vue?vue&type=script&lang=ts&"
import style0 from "./MigrationNotice.vue?vue&type=style&index=0&id=85fc3996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fc3996",
  null
  
)

export default component.exports